// Luminance units with conversion factors to candela per square meter (cd/m²)
export const luminanceUnits = [
  { id: 'candela-per-sqmeter', name: 'Candela/Square Meter', symbol: 'cd/m²', plural: 'Candela/Square Meter', factor: 1 },
  { id: 'candela-per-sqcentimeter', name: 'Candela/Square Centimeter', symbol: 'cd/cm²', plural: 'Candela/Square Centimeter', factor: 10000 },
  { id: 'candela-per-sqfoot', name: 'Candela/Square Foot', symbol: 'cd/ft²', plural: 'Candela/Square Foot', factor: 10.7639104 },
  { id: 'candela-per-sqinch', name: 'Candela/Square Inch', symbol: 'cd/in²', plural: 'Candela/Square Inch', factor: 1550.0031 },
  { id: 'kilocandela-per-sqmeter', name: 'Kilocandela/Square Meter', symbol: 'kcd/m²', plural: 'Kilocandela/Square Meter', factor: 1000 },
  { id: 'stilb', name: 'Stilb', symbol: 'sb', plural: 'Stilbs', factor: 10000 },
  { id: 'lumen-per-sqmeter-per-sr', name: 'Lumen/sq m/steradian', symbol: 'lm/(m²·sr)', plural: 'Lumen/sq m/steradian', factor: 1 },
  { id: 'lumen-per-sqcm-per-sr', name: 'Lumen/sq cm/steradian', symbol: 'lm/(cm²·sr)', plural: 'Lumen/sq cm/steradian', factor: 10000 },
  { id: 'lumen-per-sqft-per-sr', name: 'Lumen/sq ft/steradian', symbol: 'lm/(ft²·sr)', plural: 'Lumen/sq ft/steradian', factor: 10.7639104 },
  { id: 'watt-per-sqcm-per-sr', name: 'Watt/sq cm/steradian', symbol: 'W/(cm²·sr)', plural: 'Watt/sq cm/steradian', factor: 6830000 },
  { id: 'nit', name: 'Nit', symbol: 'nt', plural: 'Nits', factor: 1 },
  { id: 'millinit', name: 'Millinit', symbol: 'mnt', plural: 'Millinits', factor: 0.001 },
  { id: 'lambert', name: 'Lambert', symbol: 'L', plural: 'Lamberts', factor: 3183.0988618 },
  { id: 'millilambert', name: 'Millilambert', symbol: 'mL', plural: 'Millilamberts', factor: 3.1830988618 },
  { id: 'foot-lambert', name: 'Foot-lambert', symbol: 'fL', plural: 'Foot-lamberts', factor: 3.4262590996 },
  { id: 'apostilb', name: 'Apostilb', symbol: 'asb', plural: 'Apostilbs', factor: 0.3183098862 },
  { id: 'blondel', name: 'Blondel', symbol: 'blondel', plural: 'Blondels', factor: 0.3183098862 },
  { id: 'bril', name: 'Bril', symbol: 'bril', plural: 'Brils', factor: 3.1830988618e-8 },
  { id: 'skot', name: 'Skot', symbol: 'skot', plural: 'Skots', factor: 0.0003183098862 },
];

export const popularLuminanceConversions = [
  { from: 'candela-per-sqmeter', to: 'foot-lambert' },
  { from: 'foot-lambert', to: 'candela-per-sqmeter' },
  { from: 'candela-per-sqmeter', to: 'nit' },
  { from: 'stilb', to: 'candela-per-sqmeter' },
  { from: 'lambert', to: 'candela-per-sqmeter' },
  { from: 'candela-per-sqmeter', to: 'lambert' },
];

export const getUnitById = (id) => luminanceUnits.find(unit => unit.id === id);

export const convertLuminance = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert luminance units and learn the conversion formula.`;
};
